import {Transform} from "./Transform";
import PhoneController from "../controllers/PhoneController";


export default new (class TransformAccount extends Transform {
    get(body = null) {
        let data = this.checkAndTakeJson(body);

        return {
            account: this.account(data.account),
            profile: this.profile(data.profile),
            addresses: this.checkAndTakeArray(data.addresses).map(i => this.address(i)),
            credits: this.checkAndTakeArray(data.credits).map(i => this.credit(i)),
        };
    }

    profile(data = null) {

        data = this.checkAndTakeJson(data);

        return {
            emailConfirmed: this.takeBoolean(data, "emailConfirmed", false),
            fullName: this.takeString(data, "fullName", ""),
            genderType: this.takeNumber(data, "genderType", 2),
            firstName: this.takeString(data, "firstName", ""),
            lastName: this.takeString(data, "lastName", ""),
            email: this.takeString(data, "email", ""),
            phoneNumber: PhoneController.format(this.takeString(data, "phoneNumber", "")),
            points: this.takeNumber(data, "points", 0),
            walletBalance: this.takeNumber(data, "walletBalance", 0),
            customerToken: this.takeString(data, "customerToken", "")
        };
    }

    profileToCheckout(data = null) {
        let profile = this.profile(data);

        return {
            gender: this.takeNumber(profile, "genderType", 1),
            firstname: this.takeString(profile, "firstName", ""),
            lastname: this.takeString(profile, "lastName", ""),
            email: this.takeString(profile, "email", ""),
            phone: PhoneController.format(this.takeString(profile, "phoneNumber", "")),
            customerToken: this.takeString(data, "customerToken", "")
        };
    }

    account(data = null) {
        let account = this.checkAndTakeJson(data);
        return {
            fullName: this.takeString(account, "fullName", ""),
            token: this.takeString(account, "token", ""),
            username: this.takeString(
                account,
                "username",
                this.takeString(account, "userName", "")
            ),
        };
    }

    address(data = null) {
        data = this.checkAndTakeJson(data);
        return {
            id: this.takeNumber(data, "id", -1),
            title: this.takeString(data, "title", ""),
            provinceId: this.takeNumber(data, "provinceId", 8),
            countryId: this.takeNumber(data, "countryId", 1),
            provinceTitle: this.takeString(data, "provinceTitle", ""),
            countryTitle: this.takeString(data, "countryTitle", ""),
            city: this.takeString(data, "city", ""),
            address: this.takeString(data, "address", ""),
            apartment: this.takeString(data, "apartment", ""),
            buzzer: this.takeString(data, "buzzer", ""),
            houseNo: this.takeString(data, "houseNo", ""),
            latitude: this.takeNumber(data, "latitude", 0),
            longitude: this.takeNumber(data, "longitude", 0),
            postalCode: this.takeString(data, "postalCode", ""),
            startNumber: this.takeString(data, "startNumber", ""),
        };
    }

    credit(data = null) {
        data = this.checkAndTakeJson(data);
        return {
            deleted: this.takeBoolean(data, "deleted", false),
            expireDate: this.takeString(data, "expireDate", ""),
            last4Number: this.takeString(data, "last4Number", ""),

            id: this.takeString(data, "id", ""), // data.hasOwnProperty('id') ? data.id : "",
            name: this.takeString(data, "name", ""), //data.hasOwnProperty('name') ? data.name : "",
            holderName: this.takeString(data, "holderName", ""), //data.hasOwnProperty('holderName') ? data.holderName : "",
            number: this.takeString(data, "number", ""), //data.hasOwnProperty('number') ? data.number : "",
            cvc: this.takeString(data, "cvc", ""), //data.hasOwnProperty('cvc') ? data.cvc : "",
            expireYear: this.takeString(data, "expireYear", ""), // data.hasOwnProperty('expireYear') ? data.expireYear : "",
            expireMonth: this.takeString(data, "expireMonth", ""), // data.hasOwnProperty('expireMonth') ? data.expireMonth : "",
            postalCode: this.takeString(data, "postalCode", ""), //data.hasOwnProperty('postalCode') ? data.postalCode : "",
        };
    }

    wallet(data = null) {
        data = this.checkAndTakeJson(data);
        return {
            status: this.takeBoolean(data, "status", false),
            balance: this.takeNumber(data, "balance", 0),
        };
    }

    walletInformation(data = null) {
        data = this.checkAndTakeJson(data);
        return {
            minimumRechargeAmount: this.takeNumber(data, "minimumRechargeAmount", 0),
            maximumRechargeAmount: this.takeNumber(data, "maximumRechargeAmount", 0),
            maximumBalance: this.takeNumber(data, "maximumBalance", 0),
            policyAndAgreementLink: this.takeString(data, "policyAndAgreementLink", ""),
            url: this.takeString(data, "url", ""),
        };
    }

    toEditCredit(data = null) {
        let card = this.credit(data);
        return {
            ...card,
            last4Number: "XXXX - XXXX - XXXX - " + card.last4Number,
            expireMonth:
                +card.expireMonth < 10
                    ? "0" + card.expireMonth
                    : card.expireMonth,
        };
    }

    toAddCredit(credit = null) {
        let data = this.credit(credit);

        return {
            id: "",
            name: data.name,
            holderName: data.holderName,
            number: data.number,
            cvc: data.cvc,
            expireYear: data.expireYear,
            expireMonth: data.expireMonth,
            postalCode: data.postalCode,
        };
    }

    creditsToTextValue(credits) {
        let data = this.checkAndTakeArray(credits);
        data = data.map((item) => this.credit(item));
        return data.map((item) => ({
            text: <span style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: "space-between",
                alignItems: 'center'
            }}><span>{item.name}</span> <span>{item.last4Number}</span></span>,
            value: item.id
        }));
    }

    toSaveProfile = (data = null) => {
        data = this.profile(data);
        data.phoneNumber = PhoneController.unformat(data.phoneNumber);
        return data;
    };

    forRegister = (form = null) => {
        const data = this.checkAndTakeJson(form);

        return {
            phone: PhoneController.unformat(PhoneController.format(this.takeString(data, "phone", ""))),
            email: this.takeString(data, "email", ""),
            repass: this.takeString(data, "repass", ""),
            password: this.takeString(data, "password", ""),
            gender: this.takeString(data, "gender", 2),
            firstname: this.takeString(data, "firstname", ""),
            lastname: this.takeString(data, "lastname", ""),
            code: this.takeString(data, "code", ""),
            verification: this.takeBoolean(data, "verification", false),
            emailConfirmation: this.takeBoolean(data, "emailConfirmation", false),
        };
    };

    checkoutToRegisterForm(checkout) {
        const data = this.checkAndTakeJson(checkout);

        return {
            phone: PhoneController.unformat(PhoneController.format(this.takeString(data, "phone", ""))),
            email: this.takeString(data, "email", ""),
            repass: this.takeString(data, "password", ""),
            password: this.takeString(data, "password", ""),
            gender: this.takeString(data, "gender", 2),
            firstname: this.takeString(data, "firstname", ""),
            lastname: this.takeString(data, "lastname", ""),
            code: this.takeString(data, "phoneVerificationCode", ""),
        };
    }


})();
